import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  Button,
  CheckPicker,
  Whisper,
  Tooltip,
  Icon,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import moment from 'moment'

export default function ProposalAllDetailForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [showMore, setShowMore] = useState('show')

  const buttonMoreText = 'เงื่อนไขเพิ่มเติม'

  const tooltip = (
    <Tooltip>
      {showMore == 'show' ? (
        <>
          <div style={{ marginTop: 5 }}>กดเพื่อแสดงเงื่อนไขการค้นหาเพิ่มเติม</div>
        </>
      ) : (
        <>
          <div style={{ marginTop: 5 }}>กดเพื่อซ่อนเงื่อนไขการค้นหาเพิ่มเติม</div>
        </>
      )}
    </Tooltip>
  )

  useEffect(() => {
    if (!clearValue) {
      setStartDate(null)
      setEndDate(null)
    }
  }, [clearValue])

  const handleClickShow = () => {
    setShowMore('hide')
    document.getElementById('objMore').style.display = 'block'
    document.getElementById('hideMore').style.display = 'block'
    document.getElementById('showMore').style.display = 'none'
  }

  const handleClickHide = () => {
    setShowMore('show')
    document.getElementById('objMore').style.display = 'none'
    document.getElementById('hideMore').style.display = 'none'
    document.getElementById('showMore').style.display = 'block'
  }

  return (
    <Form>
      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectCode.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.projectCode.name}
            defaultValue={schema.projectCode.value}
            placeholder={schema.projectCode.hint || `ระบุรหัสโครงการ`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectName.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.projectName.name}
            defaultValue={schema.projectName.value}
            placeholder={schema.projectName.hint || `ระบุชื่อโครงการ`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.contactNo.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.contactNo.name}
            defaultValue={schema.contactNo.value}
            placeholder={schema.contactNo.hint || `ระบุเลขที่สัญญา`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectStatus.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <ErrorMessage error={errors[schema.projectStatus.name]} />
          {/* <Controller
            name={schema.projectStatus.name}
            control={control}
            defaultValue={schema.projectStatus.value}
            // rules={isValidators(schema.projectStatusOption.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={schema.projectStatus.options}
                  // disabled={disabledValue.constYear}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                    // onChangeMainProject(value)
                  }}
                />
              )
            }}
          /> */}
          <Controller
            name={schema.projectStatus.name}
            control={control}
            rules={isValidators(schema.projectStatus.validators)}
            // defaultValue={schema.projectStatus.options.map((columns) => {
            //   const { value } = columns
            //   return value
            // })}
            render={(props) => {
              return (
                <CheckPicker
                  sticky
                  data={schema.projectStatus.options}
                  defaultValue={schema.projectStatus.defaultValue}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                    // console.log('x => ', value)
                    // onChangeMainProject(value)
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectStartDate.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <ErrorMessage error={errors[schema.projectStartDate.name]} />
          <Controller
            key={schema.projectStartDate.name}
            name={schema.projectStartDate.name}
            control={control}
            defaultValue={
              schema.projectStartDate.value
                ? moment(schema.projectStartDate.value, DATE_PICKER_FORMAT).toDate()
                : null
            }
            // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
            render={(props) => {
              return (
                <DatePicker
                  format="DD/MM/YYYY"
                  locale={LOCAL_DAY_TH}
                  block
                  value={startDate}
                  onChange={(value) => {
                    const date = moment(value).format(DATE_PICKER_FORMAT)
                    props.onChange(value)
                    setStartDate(value)
                  }}
                  disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                />
              )
            }}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectEndDate.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <ErrorMessage error={errors[schema.projectEndDate.name]} />
          <Controller
            key={schema.projectEndDate.name}
            name={schema.projectEndDate.name}
            control={control}
            defaultValue={
              schema.projectEndDate.value
                ? moment(schema.projectEndDate.value, DATE_PICKER_FORMAT).toDate()
                : null
            }
            // rules={isValidators(schema.preApprovedProjectEndDate.validators)}
            render={(props) => {
              return (
                <DatePicker
                  format="DD/MM/YYYY"
                  locale={LOCAL_DAY_TH}
                  block
                  value={endDate}
                  onChange={(value) => {
                    const date = moment(value).format(DATE_PICKER_FORMAT)
                    props.onChange(value)
                    setEndDate(value)
                  }}
                  disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
                />
              )
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.firstNameProjectCoordinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.firstNameProjectCoordinator.name}
            defaultValue={schema.firstNameProjectCoordinator.value}
            placeholder={schema.firstNameProjectCoordinator.hint || `ระบุชื่อผู้ประสาน`}
            inputRef={register()}
          />
        </Col>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.lastNameProjectCoordinator.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <Input
            name={schema.lastNameProjectCoordinator.name}
            defaultValue={schema.lastNameProjectCoordinator.value}
            placeholder={schema.lastNameProjectCoordinator.hint || `ระบุนามสกุลผู้ประสาน`}
            inputRef={register()}
          />
        </Col>
      </Row>

      <Row>
        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectDepartment.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <ErrorMessage error={errors[schema.projectDepartment.name]} />
          <Controller
            name={schema.projectDepartment.name}
            control={control}
            defaultValue={schema.projectDepartment.value}
            // rules={isValidators(schema.projectDepartment.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={schema.projectDepartment.options}
                  // disabled={disabledValue.constYear}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                    // onChangeMainProject(value)
                  }}
                />
              )
            }}
          />
        </Col>

        <Col
          lg={5}
          md={5}
          sm={8}
          xs={8}
          style={{
            marginTop: '5px',
            padding: '8px',
            textAlign: 'right',
          }}
        >
          {schema.projectRoundNo.label}
        </Col>
        <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
          <ErrorMessage error={errors[schema.projectRoundNo.name]} />
          <Controller
            name={schema.projectRoundNo.name}
            control={control}
            defaultValue={schema.projectRoundNo.value}
            // rules={isValidators(schema.projectRoundNo.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={schema.projectRoundNo.options}
                  // disabled={disabledValue.constYear}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                    // onChangeMainProject(value)
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }} id="showMore">
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
          <hr style={{ borderTop: '2px solid #2da888 !important' }} />
          <div style={{ position: 'relative', fontSize: 12, marginTop: -38, fontWeight: 'bold' }}>
            <Whisper
              placement="bottom"
              controlId="control-id-hover"
              trigger="hover"
              speaker={tooltip}
            >
              <Button
                appearance="primary"
                style={{
                  backgroundColor: '#fff',
                  color: '#2da888',
                  fontSize: '12px !important',
                  fontWeight: 'bold',
                }}
                onClick={handleClickShow}
              >
                <Icon icon="angle-double-down" /> {`  ${buttonMoreText} `}{' '}
                <Icon icon="angle-double-down" />
              </Button>
            </Whisper>
          </div>
          <br />
        </Col>
      </Row>

      {/* style={{ marginTop: 20, display: 'none' }} */}
      <div id="objMore" style={{ marginTop: 20, display: 'none' }}>
        {/* <div> */}
        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              textAlign: 'right',
              color: '#2da888',
            }}
          >
            <b>
              <u>ผู้รับผิดชอบโครงการ</u>
            </b>
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.firstNameResponsinator.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.firstNameResponsinator.name}
              defaultValue={schema.firstNameResponsinator.value}
              placeholder={schema.firstNameResponsinator.hint || `ระบุชื่อ`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.lastNameResponsinator.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.lastNameResponsinator.name}
              defaultValue={schema.lastNameResponsinator.value}
              placeholder={schema.lastNameResponsinator.hint || `ระบุสกุล`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.responsinatorIdCard.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.responsinatorIdCard.name}
              defaultValue={schema.responsinatorIdCard.value}
              placeholder={schema.responsinatorIdCard.hint || `ระบุเลขที่บัตรประชาชน`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.responsinatorTelephone.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.responsinatorTelephone.name}
              defaultValue={schema.responsinatorTelephone.value}
              placeholder={schema.responsinatorTelephone.hint || `ระบุเบอร์โทร`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.responsinatorEmail.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.responsinatorEmail.name}
              defaultValue={schema.responsinatorEmail.value}
              placeholder={schema.responsinatorEmail.hint || `ระบุอีเมล`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              textAlign: 'right',
              color: '#2da888',
            }}
          >
            <b>
              <u>ผู้รับทุน</u>
            </b>
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.firstNameGrentree.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.firstNameGrentree.name}
              defaultValue={schema.firstNameGrentree.value}
              placeholder={schema.firstNameGrentree.hint || `ระบุชื่อ`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.lastNameGrentree.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.lastNameGrentree.name}
              defaultValue={schema.lastNameGrentree.value}
              placeholder={schema.lastNameGrentree.hint || `ระบุสกุล`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.grentreeIdCard.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.grentreeIdCard.name}
              defaultValue={schema.grentreeIdCard.value}
              placeholder={schema.grentreeIdCard.hint || `ระบุเลขที่บัตรประชาชน`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.grentreeTelephone.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.grentreeTelephone.name}
              defaultValue={schema.grentreeTelephone.value}
              placeholder={schema.grentreeTelephone.hint || `ระบุเบอร์โทรศัพ`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.grentreeEmail.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.grentreeEmail.name}
              defaultValue={schema.grentreeEmail.value}
              placeholder={schema.grentreeEmail.hint || `ระบุอีเมล`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              textAlign: 'right',
              color: '#2da888',
            }}
          >
            <b>
              <u>องค์กรผู้รับทุน</u>
            </b>
          </Col>
        </Row>

        <Row>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.organization.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.organization.name}
              defaultValue={schema.organization.value}
              placeholder={schema.organization.hint || `ระบุองค์กรผู้รับทุน`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={5}
            md={5}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.taxNo.label}
          </Col>
          <Col lg={7} md={7} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.taxNo.name}
              defaultValue={schema.taxNo.value}
              placeholder={schema.taxNo.hint || `ระบุเลขที่ผู้เสียภาษี`}
              inputRef={register()}
            />
          </Col>
        </Row>
      </div>

      <Row style={{ marginTop: 10, display: 'none' }} id="hideMore">
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
          <hr />
          <div style={{ position: 'relative', fontSize: 12, marginTop: -38, fontWeight: 'bold' }}>
            <Whisper
              placement="bottom"
              controlId="control-id-hover"
              trigger="hover"
              speaker={tooltip}
            >
              <Button
                appearance="primary"
                style={{
                  backgroundColor: '#fff',
                  color: '#2da888',
                  fontSize: '12px !important',
                  fontWeight: 'bold',
                }}
                onClick={handleClickHide}
              >
                <Icon icon="angle-double-up" /> {`  ${buttonMoreText} `}{' '}
                <Icon icon="angle-double-up" />
              </Button>
            </Whisper>
          </div>
        </Col>
      </Row>
    </Form>
  )
}
